// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SihaDownloadDocumentRequestModel from '../../model/siha-download-document-request-model';
import SihaDownloadDocumentRequestDTO from '../dto/siha-download-document-request-dto';
import dtoSchema from '../schemas/siha-download-document-request-schema';

export default abstract class SihaDownloadDocumentRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SihaDownloadDocumentRequestDTO>) {
    super();
    if (data) {
      this.externalId = data.externalId;
    }
  }
  /**
  */
  externalId?: string;

  static toModel(dto: DeepPartial<SihaDownloadDocumentRequestDTO>): SihaDownloadDocumentRequestModel;
  static toModel(dto: DeepPartial<SihaDownloadDocumentRequestDTO> | undefined | null): SihaDownloadDocumentRequestModel | undefined;
  static toModel(dto: DeepPartial<SihaDownloadDocumentRequestDTO> | undefined | null): SihaDownloadDocumentRequestModel | undefined {
    return dto ? new SihaDownloadDocumentRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SihaDownloadDocumentRequestModel> | SihaDownloadDocumentRequestModel): SihaDownloadDocumentRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      externalId: unwrapped.externalId,
    } as SihaDownloadDocumentRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SihaDownloadDocumentRequestModel, can not map to SihaDownloadDocumentRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
